import { type EmployeeAuthContact } from '../../../shared/hooks/use-employee-session';
import {
  formatPhoneByMask,
  isPhoneLengthComplete,
} from '../../../shared/model';

export function resolveVerifyPhonePreview(
  contact: EmployeeAuthContact | null,
): string | null {
  if (!contact) {
    return null;
  }

  if (!isPhoneLengthComplete(contact.phoneDigits.length)) {
    return null;
  }

  return `${contact.countryCode} ${formatPhoneByMask(
    contact.phoneDigits,
    contact.countryCode,
  ).replace(/\d(?=(?:\D*\d){4})/g, '*')}`;
}
